(function() { window.GUID_0bcd059f_434f_49f4_9412_fc3ec14cea5b = { getGuid: function() { return "0bcd059f-434f-49f4-9412-fc3ec14cea5b"; } }; })();
var CS;
(function (CS) {
    class User {
        User() {
        }
        static CheckIfAnythingToDo(jqXHR) {
            CS.UserHangfireTasks.CheckIfAnyTasks(jqXHR);
            CS.UserDisclaimer.CheckIfAnyDisclaimer(jqXHR);
        }
    }
    CS.User = User;
})(CS || (CS = {}));

//# sourceMappingURL=User.js.map
